// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Cw-z","tooltipWrapper":"Dw-z","icon":"Ew-z","tooltip":"Fw-z","content":"Gw-z"};